import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=7f2adbde&scoped=true"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"
import style0 from "./FormText.vue?vue&type=style&index=0&id=7f2adbde&prod&lang=scss"
import style1 from "./FormText.vue?vue&type=style&index=1&id=7f2adbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2adbde",
  null
  
)

export default component.exports